export default __webpack_public_path__ + "static/qualys-95815764bde8cc9370ca3616605b4f07.jpg";